














































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { MenuItem, menuItems } from '@/config/menu-items';

import QuestionIcon from '@/components/Helper/Icon/Svg/QuestionIcon.vue';
import Cheeers3Icon from '@/components/Helper/Icon/Svg/Cheeers3Icon.vue';
import NoteIcon from '@/components/Helper/Icon/Svg/NoteIcon.vue';
import GraduationHatIcon from '@/components/Helper/Icon/Svg/GraduationHatIcon.vue';
import CashIcon from '@/components/Helper/Icon/Svg/CashIcon.vue';
import SettingsIcon from '@/components/Helper/Icon/Svg/SettingsIcon.vue';
import MissionIcon from '@/components/Helper/Icon/Svg/MissionIcon.vue';
import { mapGetters, mapActions } from 'vuex';
import { StaffEntity } from '@/entities/staff.entity';

@Component<Drawer>({
  components: {
    CashIcon,
    GraduationHatIcon,
    NoteIcon,
    Cheeers3Icon,
    QuestionIcon,
    SettingsIcon,
    MissionIcon,
  },
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
  methods: {
    ...mapActions('staff', ['refreshNotify']),
  },
})
export default class Drawer extends Vue {
  refreshNotify!: () => Promise<void>;
  @Prop({ type: Boolean })
  value: boolean;
  currentStaff!: StaffEntity;
  menuItems: MenuItem[] = menuItems;
  ICON_QUESTION = 'question-icon';
  ICON_NOTE = 'note-icon';

  IsShowNotifyIssues(item: { icon: string }) {
    if (item.icon === this.ICON_QUESTION) {
      return Number(this.currentStaff.unreadNotifyIssue) > 0;
    }
    if (item.icon === this.ICON_NOTE) {
      return Number(this.currentStaff.unreadNotifyBulletin) > 0;
    }
    return false;
  }
  created() {
    if (this.$route.path.includes('issue') || this.$route.path.includes('bulletin')) {
      this.$cheeers.socket.on('notifyToIssue', () => {
        this.refreshNotify();
      });
      this.$cheeers.socket.on('notifyToBulletin', () => {
        this.refreshNotify();
      });
    }
  }
}
